(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('FirebaseTokenDetailController', FirebaseTokenDetailController);

    FirebaseTokenDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'FirebaseToken', 'Customer'];

    function FirebaseTokenDetailController($scope, $rootScope, $stateParams, previousState, entity, FirebaseToken, Customer) {
        var vm = this;

        vm.firebaseToken = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('bozorakaAdminApp:firebaseTokenUpdate', function(event, result) {
            vm.firebaseToken = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
